import React from 'react'

interface ButtonProps {
  children: React.ReactNode
  onClick?: () => void
  type?: 'button' | 'submit' | 'reset'
  disabled?: boolean
  className?: string
  variant?: 'small' | 'medium' | 'large' | 'xlarge'
}

const BlueButton: React.FC<ButtonProps> = ({
  children,
  onClick,
  type = 'button',
  disabled = false,
  className = '',
  variant = 'medium'
}) => {
  const variantStyles = {
    small: {
      container: 'px-3 py-2 gap-1.5',
      text: 'text-[13px] leading-[20px] font-[500] ',
      fontStretch: 'font-stretch-100'
    },
    medium: {
      container: 'px-3 py-2 gap-1.5',
      text: 'text-sm leading-5 font-medium ',
      fontStretch: ''
    },
    large: {
      container: 'px-6 py-3 gap-2',
      text: 'text-[18px] leading-[20px] font-[500] ',
      fontStretch: ''
    },
    xlarge: {
      container: 'px-6 py-3 gap-2',
      text: 'text-[18px] leading-[20px] font-[400] ',
      fontStretch: ''
    }
  }

  const currentVariant = variantStyles[variant]

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`
        ${currentVariant.container}
        flex flex-row justify-center items-center
        bg-[#3582CE] text-[#F8FAFC]
        shadow-[0px_1px_2px_#00598A,0px_0px_0px_1px_#3582CE,inset_0px_0.75px_0px_rgba(255,255,255,0.2)]
        rounded-md
        ${currentVariant.text}
        ${variant === 'small' || variant === 'xlarge' ? currentVariant.fontStretch : ''}
        hover:bg-[#2B6BB8] hover:shadow-[0px_2px_4px_#00598A,0px_0px_0px_1px_#2B6BB8,inset_0px_0.75px_0px_rgba(255,255,255,0.3)]
        active:bg-[#1E5AA3] active:shadow-[0px_1px_2px_#00598A,0px_0px_0px_1px_#1E5AA3,inset_0px_1px_0px_rgba(255,255,255,0.1)]
        disabled:bg-gray-400 disabled:shadow-none disabled:cursor-not-allowed
        hover:transition-all hover:duration-200
        active:transition-all active:duration-200
        ${className}
      `}>
      {children}
    </button>
  )
}

export default BlueButton
